// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import React from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';

type GhostAvatarProps = {
  /** Outer diameter in pixels; matches the avatar slot it replaces. */
  size?: number;
  style?: StyleProp<ViewStyle>;
};

/**
 * Avatar shown for AI players (pure AI opponents and ghosts of real players) wherever
 * a profile picture would appear. AI players never have an uploaded image, so this is
 * their visual identity across player lists, scoring and leaderboards.
 */
export default function GhostAvatar({ size = 28, style }: GhostAvatarProps) {
  return (
    <View
      style={[
        styles.circle,
        { width: size, height: size, borderRadius: size / 2 },
        style,
      ]}
      accessibilityRole="image"
    >
      <MaterialCommunityIcons name="ghost" size={Math.round(size * 0.66)} color="#5E6E80" />
    </View>
  );
}

const styles = StyleSheet.create({
  circle: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E4EAF1',
    borderWidth: 1,
    borderColor: '#C5D0DC',
  },
});
